export default __webpack_public_path__ + "static/media/4689@2x.6c0cba1f.png";